import React, { Component, Fragment } from 'react'
import '../../styles/Popup.module.css'
import {
    Form,
    Select,
    Input,
    Button,
    Upload,
    Row,
    Col,
} from 'antd';
import ImgCrop from 'antd-img-crop';
import ReactDropzone from "react-dropzone";
import { connect } from 'react-redux';
import { requestServerPost, selectPage } from '../../actions';

import { UploadOutlined, InboxOutlined } from '@ant-design/icons';
import PopupManager from '../../managers/PopupManager';
import ScreenSelectorPopup from './ScreenSelectorPopup';
import PlaylistScreenSelectorPopup from './PlaylistScreenSelectorPopup';
const { Option } = Select;


class AssignAndPublishPage extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        console.log("AssignAndPublishPage mounted");
    }

    componentWillUnmount() {
        console.log("AssignAndPublishPage unmounted");
    }


    render() {
        const { requestServerPost, usertoken, selectedBrandData, campaignData = null, playlistData=null } = this.props;
        const previewStyle = {
            display: 'inline',
            width: 100,
            height: 100,
        };

        if(campaignData){
            return (
                <div className="popupcontentcontainer" style={{ height: "100%", width:"100%" }}>
                    <ScreenSelectorPopup campaignData={campaignData}></ScreenSelectorPopup>
                </div >
            );
        }
        else if(playlistData)
        {
            return (
                <div className="popupcontentcontainer" style={{ height: "100%", width:"100%" }}>
                    <PlaylistScreenSelectorPopup playlistData={playlistData}></PlaylistScreenSelectorPopup>
                </div >
            );
        }

        return null
    }
}

const Styles = {

}


const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, selectedBrandData: state.selectedBrandData };
}

export default connect(mapStateToProps, { requestServerPost, requestServerPost, selectPage })(AssignAndPublishPage);
